export const OWNER = 'owner'
export const MANAGER = 'manager'
export const CASHIER = 'cashier'
export const SALE_STAFF = 'sale staff'
export const SERVICE_STAFF = 'service staff'
export const GENERAL_MANAGER = 'general manager'
